import { useCallback } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { useReactNodeView } from '@lyearn/lygo-core';
import { useSnackbar } from '@lyearn/ui';

const useHandleUpload = () => {
  const { showErrorSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const { updateAttrs } = useReactNodeView();
  return useCallback(
    (uploader: Promise<File | string | undefined>) =>
      uploader?.catch(() => {
        updateAttrs({ src: null });
        showErrorSnackbar({ message: t('Lygo:Error.InvalidImageUrl') });
      }),
    [showErrorSnackbar, t, updateAttrs],
  );
};

export default useHandleUpload;
